(() => {
  const roots = new WeakSet();

  const init = (root) => {
    if (!root || roots.has(root)) return;
    roots.add(root);

    const slides = Array.from(root.querySelectorAll('[data-vch-slide]'));
    if (slides.length < 2) return;

    const warmed = new Set();
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const perView = () => desktopQuery.matches ? 2 : 1;

    const preloadSlide = (index) => {
      if (index < 0 || index >= slides.length || warmed.has(index)) return;

      const picture = slides[index].querySelector('picture');
      const img = picture?.querySelector('img');
      if (!img) return;

      warmed.add(index);
      const preloadImage = new Image();
      preloadImage.decoding = 'async';
      preloadImage.fetchPriority = 'low';

      const mobileSource = !desktopQuery.matches ? picture.querySelector('source') : null;
      if (mobileSource?.srcset) {
        preloadImage.srcset = mobileSource.srcset;
        preloadImage.sizes = '100vw';
        preloadImage.src = mobileSource.srcset.split(',')[0].trim().split(/\s+/)[0];
      } else {
        if (img.srcset) preloadImage.srcset = img.srcset;
        preloadImage.sizes = img.sizes || (desktopQuery.matches ? '50vw' : '100vw');
        preloadImage.src = img.currentSrc || img.src;
      }
    };

    const warmPage = (page) => {
      const count = Math.ceil(slides.length / perView());
      if (count <= 1) return;
      const normalized = (page + count) % count;
      const start = normalized * perView();
      for (let offset = 0; offset < perView(); offset += 1) {
        preloadSlide(start + offset);
      }
    };

    const warmAdjacent = () => {
      const page = Number(root.dataset.vchPage || 0);
      warmPage(page + 1);
      warmPage(page - 1);
    };

    const scheduleWarm = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmAdjacent, { timeout: 700 });
      } else {
        window.setTimeout(warmAdjacent, 220);
      }
    };

    scheduleWarm();
    root.addEventListener('vch:pagechange', scheduleWarm);
  };

  const boot = () => {
    document.querySelectorAll('[data-volices-campaign-slider]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
